/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import PartnerBookVirtualTable from './PartnerBookVirtualTable';

import '../PartnerBook.scss';

function PartnerBookTable({
  view,
  bookDates,
  bookColumns,
  bookHeaders,
  bookComments,
  bookPartners,
  bookOperations,
  bookTotals,
  bookTotalPartners,
  bookOrder,
  bookDocuments,
  isForScreen = false,
}) {
  if (!isForScreen) {
    return null;
  }

  return (
    <div className={view === 0 && isForScreen ? 'nk-block' : 'd-none'}>
      <PartnerBookVirtualTable
        bookDates={bookDates}
        bookColumns={bookColumns}
        bookHeaders={bookHeaders}
        bookComments={bookComments}
        bookPartners={bookPartners}
        bookOperations={bookOperations}
        bookTotals={bookTotals}
        bookTotalPartners={bookTotalPartners}
        bookOrder={bookOrder}
        bookDocuments={bookDocuments}
      />
    </div>
  );
}

export default PartnerBookTable;
